/**
 * Hit again › Texts (21/10/2026 — user: "this option should be also available
 * inside the hit again THEN → Texts"): what the hit-again drop sends, as the
 * same choice Creative › Text ranking › Config offers on its hit-again line —
 * the texts of the drop that hit, or new texts — ★ proven + ✦ fresh AI,
 * the two numbers in place (21/10/2026 later: "own" was not clear). One setting, written from either place:
 * Hit again's texts (the verdict row's hitTextsJson) — a Verdicts value, so a container that follows the
 * master's Verdicts follows it too, whatever Texts section it keeps.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { MessageSquareText } from 'lucide-react';
import { type DropGenTextMix, type DropGenTextMixInput, keepsCopiedTexts, mixFor, RECOMMENDED_BET_MIX } from '@trafficpulse/shared';

import { MixCell } from '../../../creative/ranking/fill/today/MixCell';
import { ChoiceChips } from '../../../general/controls/ChoiceChips';
import { HitRow } from './HitGrid';

const CHOICES = [
  { value: 'copy', label: 'the texts of the drop that hit' },
  { value: 'own', label: 'new texts: ★ proven + ✦ AI' },
] as const;

const NOTE = 'The same setting as Creative › Text ranking › Config › hit-again drop — change it here or there. It belongs to Hit again: it follows the master with the rest of this card. New texts: ★ proven texts from the reuse pool + ✦ fresh AI texts on the same drop — the two numbers say how many of each.';

interface Props {
  /** The draft's text mix input (the ordinary mix and the kinds' own). */
  cfg: DropGenTextMixInput;
  /** Writes the hit-again kind's mix (new texts); undefined = back to the texts of the drop that hit. */
  onPolicy: (mix: DropGenTextMix | undefined) => void;
}

export const HitTextsRow: FC<Props> = ({ cfg, onPolicy }) => {
  const own = !keepsCopiedTexts(cfg, 'HIT_AGAIN');
  const asked = mixFor(cfg, 'HIT_AGAIN');
  return (
    <HitRow icon={MessageSquareText} label="Texts" testId="hit-texts" note={NOTE}>
      <ChoiceChips ariaLabel="What the hit-again drop sends" options={CHOICES} value={own ? 'own' : 'copy'} onChange={(v) => onPolicy(v === 'own' ? (own ? asked : { ...RECOMMENDED_BET_MIX }) : undefined)} />
      {own ? <MixCell kindWords="hit-again drop" asked={asked} sends={null} onSet={onPolicy} /> : null}
    </HitRow>
  );
};
